import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier, Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import type { VaultType } from '@/entities/hooks/use-entity-vault';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
import type { EntityVault } from '@/types/vault';
import getRelevantDis from './utils/get-relevant-dis';
type UseDecryptOnboardingProps = {
  entity: Entity;
  onboarding: EntityOnboarding;
  onDecryptSuccess: (vault: VaultType) => void;
  vaultData: VaultType | undefined;
  isDecryptable: (di: DataIdentifier) => boolean | undefined;
};

/** "Decrypt all" for the vault as of an onboarding. */
const useDecryptOnboarding = t0 => {
  const $ = _c(16);
  const {
    entity,
    onboarding,
    onDecryptSuccess,
    vaultData,
    isDecryptable
  } = t0;
  const decryptControls = useDecryptControls();
  let fields;
  let t1;
  if ($[0] !== decryptControls || $[1] !== isDecryptable || $[2] !== onboarding.seqno || $[3] !== vaultData?.vault) {
    fields = getRelevantDis((Object.keys(vaultData?.vault || {}) as DataIdentifier[]).filter(isDecryptable), onboarding.seqno?.toString());
    t1 = decryptControls.isDecrypting(fields);
    $[0] = decryptControls;
    $[1] = isDecryptable;
    $[2] = onboarding.seqno;
    $[3] = vaultData?.vault;
    $[4] = fields;
    $[5] = t1;
  } else {
    fields = $[4];
    t1 = $[5];
  }
  const isDecrypting = t1;
  let t2;
  if ($[6] !== decryptControls || $[7] !== entity || $[8] !== fields || $[9] !== onDecryptSuccess || $[10] !== onboarding.id || $[11] !== onboarding.seqno) {
    t2 = async () => {
      const response = await decryptControls.decrypt({
        entity,
        fields,
        reason: `Examining onboarding ${onboarding.id}`
      });
      const vault = Object.entries(response ?? {}).reduce((acc, t3) => {
        const [key, value] = t3;
        const di = onboarding.seqno ? key.split(":")[0] : key;
        acc[di] = value;
        return acc;
      }, {} as EntityVault);
      onDecryptSuccess({
        vault,
        transforms: {}
      });
    };
    $[6] = decryptControls;
    $[7] = entity;
    $[8] = fields;
    $[9] = onDecryptSuccess;
    $[10] = onboarding.id;
    $[11] = onboarding.seqno;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const decrypt = t2;
  let t3;
  if ($[13] !== decrypt || $[14] !== isDecrypting) {
    t3 = {
      decrypt,
      isDecrypting
    };
    $[13] = decrypt;
    $[14] = isDecrypting;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
export default useDecryptOnboarding;